import { BaseSynth } from "./BaseSynth";
import { getAudioGraphInstance } from '../audioEngine';
import units from "../units.json"
import { addKeysAsField } from "../utils/misc";
import { Frequency } from "tone";
import { staticSelect } from "../utils/react";

export class MonoSynth extends BaseSynth {

    static metadata = {
        tipus: 'mono_synth',
        tipusDisplay: 'Mono Synth',
        versio: '0.1',
        hasLogo: true,
        hasMiniature: true,
    }
    static parametersDescription = addKeysAsField({
        ...super.parametersDescription,
        pianoRollColorCode: {...super.parametersDescription.pianoRollColorCode, options: ['melodic', 'none']},
        osc_portamento: {type: 'float', unit: units.second, min: 0.0, max: 1.0, initial: 0.0, bind: "preset"},
    }, "nom");
    static pitchRange = {
        ...super.pitchRange
    }
    isMono = true;

    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph({poly: false})
    }

    setParameterInAudioGraph(name, value) {
        switch (name) {
            case "osc_portamento":
                this.audioNodes.synth.set({
                    'portamento': value,
                }) 
                break;
            default:
                super.setParameterInAudioGraph(name, value);
        } 
    }

    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.synth.triggerRelease()
    }

    onStopAllSounds() {
        // Stop all notes, and set env_release time to 0
        this.setParameterInAudioGraph('env_release', 0.0);
        this.audioNodes.synth.triggerRelease();
        this.setParameterInAudioGraph('env_release', staticSelect(this.getDisplayParameterSelector('env_release')));
    }

    unfinishedNotes = [];
    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!getAudioGraphInstance().isGraphBuilt()) return;

        pitch = this.adjustPitchToInstrumentRange(pitch);
        let soundingPitch = this.adjustPitchForWaveform(pitch);
        soundingPitch += this.getPlaybackParameterValue("osc_octave") * 12;
        if (!noteOff) {
            if (!extras.skipStack) this.unfinishedNotes.push({pitch, velocity: midiVelocity});
            this.audioNodes.synth.triggerAttack(Frequency(soundingPitch, "midi"), undefined, midiVelocity/127);
        }
        else {
            const removedIndex = this.unfinishedNotes.map(({pitch}) => pitch).indexOf(pitch);
            this.unfinishedNotes.splice(removedIndex, 1);
            const newStackLength = this.unfinishedNotes.length;
            if (removedIndex === newStackLength) { // if removed note was the last one (sounding...)
                this.audioNodes.synth.triggerRelease(); // release it
                // ...and if there were other notes pressed, play the newest one among them
                if (newStackLength > 0) {
                    const newestOldNote = this.unfinishedNotes[newStackLength-1];
                    this.onMidiNote(newestOldNote.pitch, newestOldNote.velocity, false, {...extras, skipStack: true})
                }
            }
        }
        
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}
